
import Box from '~/components/svgs/box.vue';
export default {
  components: { 
    Box
  },
  props: [ 'title' ]
}
